export const NAME = 'serverInfo';
